import LandmarksBase from "BaseModels/Landmarks";

class LandmarkModel extends LandmarksBase {

}

export default LandmarkModel